import { useAllStrings } from '../settings/settings.strings.js';

/**
 * Compute the `aria-valuetext` for an ARIA range widget (e.g. `meter`, `progressbar`) based
 * on a caller-provided `format`. Returns `undefined` when the screen reader's default percent
 * announcement should apply, or when `value` is indeterminate.
 */
function useRangeValueText(value, max, format) {
    const strings = useAllStrings();
    // Screen readers announce the value as a percentage if no aria-valuetext is provided
    if (format === 'percent')
        return undefined;
    if (value === undefined)
        return undefined;
    if (format === 'absolute') {
        return strings.fraction({ value, max });
    }
    if (typeof format === 'object' && format.type === 'absolute') {
        return strings.fractionWithUnits({ value, max, unit: format.unit });
    }
    return undefined;
}

export { useRangeValueText };
//# sourceMappingURL=use-range-value-text.js.map
